export const blockIconsTransportationLocalTaxiNew = (
	<span className='material-symbols-outlined'>local_taxi</span>
);
